<template lang="html">
  <div class="alibabapayment__welcome">
    <img class="" src="@/assets/image/image/welcometoAlibabapayment.jpg" alt="">
    <div class="py-3">
      <h3 class="text-left"><b>Andalin x Alibaba</b></h3>
      <p>Bridging the needs of SMEs in gaining international markets,
        Andalin x Alibaba.com partnership aiming to open export markets for
        SMEs and make Indonesia export great again.
        <a class="fontstyle__link--blue"
            href="https://andalin.com/alibaba-gold-supplier"
            rel="noopener"
            target="_blank">Learn More!</a>
      </p>
    </div>
    <div class="text-left">
      <button type="button"
              name="button"
              @click="alibabapaymentPage"
              class="button__bluesquere">Alibaba Payment
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    alibabapaymentPage () {
      this.$emit('ispaymentpage')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/paymentAlibaba/WelcomePage.vue